var traffic = {
  "Date": "18/05/23 08:51:41",
  "Incidents": [],
  "Construction": [],
  "DriveTimes": [{
      "Id": "d325d454-67ea-4eb8-be25-12e2e909ca5c",
      "Severity": 1,
      "Length": 6.5,
      "Minutes": 8,
      "Speed": 52,
      "Start": "TULSA HILLS",
      "End": "DOWNTOWN",
      "Direction": "North|East",
      "Names": "Okmulgee Expy N|I-244 E",
      "Name": "TULSA HILLS TO DWTN"
    },
    {
      "Id": "dd2ea48f-78b5-4c59-aab3-e2ef5cda658a",
      "Severity": 1,
      "Length": 6.2,
      "Minutes": 6,
      "Speed": 66,
      "Start": "MUSKOGEE TPKE",
      "End": "US-169",
      "Direction": "West",
      "Names": "OK-51 W",
      "Name": "MKO TPKE TO US-169"
    },
    {
      "Id": "716cf07e-ad0e-4f3f-9fbc-8b8f2187b728",
      "Severity": 1,
      "Length": 7.2,
      "Minutes": 7,
      "Speed": 63,
      "Start": "DOWNTOWN TULSA",
      "End": "SAND SPRINGS",
      "Direction": "West|West",
      "Names": "I-244 W|US-412 W",
      "Name": "DOWNTOWN TO SAND SPRINGS"
    },
    {
      "Id": "c6a6645a-fed4-4ca2-9704-92d59c6db8e5",
      "Severity": 1,
      "Length": 5.5,
      "Minutes": 5,
      "Speed": 63,
      "Start": "IDL",
      "End": "I-44",
      "Direction": "East",
      "Names": "US-64 E",
      "Name": "IDL TO I-44"
    },
    {
      "Id": "5ae37eb3-46ce-4576-9482-dc8f74160c97",
      "Severity": 1,
      "Length": 5.4,
      "Minutes": 6,
      "Speed": 59,
      "Start": "I-44",
      "End": "IDL",
      "Direction": "West",
      "Names": "US-64 W",
      "Name": "I-44 TO IDL"
    },
    {
      "Id": "e8b8f3f7-b66d-4a9f-9c5d-4d0c38b08582",
      "Severity": 2,
      "Length": 13.9,
      "Minutes": 18,
      "Speed": 46,
      "Start": "BA",
      "End": "DOWNTOWN",
      "Direction": "West|North|West",
      "Names": "OK-51 W|US-169 N|US-64 W",
      "Name": "BA (LYNN LANE) TO DWTN"
    },
    {
      "Id": "41fdcce0-edb3-47c1-9670-2ef2053a1647",
      "Severity": 1,
      "Length": 12.5,
      "Minutes": 14,
      "Speed": 55,
      "Start": "SALUPA",
      "End": "DOWNTOWN",
      "Direction": "East|East",
      "Names": "I-44 E|I-244 E",
      "Name": "SAPULPA TO DWTN TULSA"
    },
    {
      "Id": "b79c219a-6a27-4329-adb8-25fa774fb4e6",
      "Severity": 1,
      "Length": 14.6,
      "Minutes": 17,
      "Speed": 53,
      "Start": "GLENPOOL",
      "End": "DOWNTOWN",
      "Direction": "North|North|North|East",
      "Names": "S Union Ave N|Okmulgee Bee Line Expy N|Okmulgee Expy N|I-244 E",
      "Name": "GLENPOOL TO DWTN "
    },
    {
      "Id": "1d597b8f-175b-4737-93f9-4840f79d8e50",
      "Severity": 3,
      "Length": 8.3,
      "Minutes": 14,
      "Speed": 37,
      "Start": "US-169 &amp; BA EXPY",
      "End": "DOWNTOWN TULSA",
      "Direction": "South|West|East",
      "Names": "US-169 S|US-64 W|I-444 E",
      "Name": "US-169 &amp; BA EXPY TO DWTN"
    },
    {
      "Id": "39c11c5f-f953-4f2f-b0a6-47ff005644fd",
      "Severity": 1,
      "Length": 18.7,
      "Minutes": 21,
      "Speed": 55,
      "Start": "GLENPOOL",
      "End": "DOWNTOWN TULSA (VIA CREEK &amp; I-44)",
      "Direction": "North|North|West|East|East",
      "Names": "S Union Ave N|Okmulgee Bee Line Expy N|OK-364 W|I-44 E|I-244 E",
      "Name": "GLENPOOL TO DWTN VIA CREEK &amp; I-44"
    },
    {
      "Id": "71c4ac7c-0a71-4815-a13d-56f94ad98364",
      "Severity": 1,
      "Length": 38.9,
      "Minutes": 35,
      "Speed": 66,
      "Start": "BARTLESVILLE",
      "End": "DOWNTOWN TULSA",
      "Direction": "South|South|South|South",
      "Names": "SE Washington Blvd S|US Highway 75 S|N Highway 75 S|US-75 S",
      "Name": "BARTLESVILLE TO DWTN TULSA"
    },
    {
      "Id": "b51e2fc2-9acd-44e9-b43d-97ef26c34def",
      "Severity": 1,
      "Length": 13,
      "Minutes": 13,
      "Speed": 62,
      "Start": "Catoosa",
      "End": "Tulsa",
      "Direction": "West|West",
      "Names": "I-44 W|I-244 W",
      "Name": "CATOOSA TO DWTN TULSA"
    },
    {
      "Id": "c32b1e45-8205-465f-b4a2-b8ed96829b88",
      "Severity": 2,
      "Length": 16.5,
      "Minutes": 23,
      "Speed": 43,
      "Start": "86TH ST N",
      "End": "I-444 Westbound - E 7th St|S Kenosha Ave to US-64",
      "Direction": "South|North|South|North|South|West",
      "Names": "US-75 S|E 36th St N|E 36th St S|E 36th St N|US-75 S|I-444 W",
      "Name": "86TH ST N TO DWTN"
    },
    {
      "Id": "5063e923-637c-459e-b5c3-3eab16b9e265",
      "Severity": 1,
      "Length": 13,
      "Minutes": 12,
      "Speed": 66,
      "Start": "Tulsa",
      "End": "I-44 Eastbound - Exit 240 to Exit 241",
      "Direction": "East|East",
      "Names": "I-244 E|I-44 E",
      "Name": "DOWNTOWN TO CATOOSA"
    },
    {
      "Id": "4bedf3e0-f40b-42bf-8f4f-614e06c8227f",
      "Severity": 1,
      "Length": 11.3,
      "Minutes": 10,
      "Speed": 67,
      "Start": "I-244",
      "End": "OWASSO",
      "Direction": "North",
      "Names": "US-169 N",
      "Name": "I-244 TO OWASSO"
    },
    {
      "Id": "0e4acaa1-bd3c-45f7-9d6f-fa135e49176d",
      "Severity": 1,
      "Length": 6.9,
      "Minutes": 7,
      "Speed": 60,
      "Start": "WILL ROGERS TPKE",
      "End": "I-244",
      "Direction": "West|West",
      "Names": "I-44 W|I-244 W",
      "Name": "WILL ROGERS TPKE TO I-244"
    },
    {
      "Id": "c7999941-559c-4fca-bc2a-e785d6bacfdb",
      "Severity": 1,
      "Length": 7.3,
      "Minutes": 7,
      "Speed": 63,
      "Start": "US-169 (I-244)",
      "End": "DOWNTOWN TULSA",
      "Direction": "South|West|North",
      "Names": "US-169 S|I-244 W|US-75 N",
      "Name": "US-169 &amp; I-244 TO DWTN"
    },
    {
      "Id": "be8b17f5-b9f3-4b6d-b0f3-741d7a951598",
      "Severity": 3,
      "Length": 5.3,
      "Minutes": 11,
      "Speed": 29,
      "Start": "BIXBY",
      "End": "CREEK TPKE",
      "Direction": "West",
      "Names": "S Memorial Dr W",
      "Name": "151ST TO CREEK TPKE"
    },
    {
      "Id": "5bb97d2f-bf03-4a00-a709-e798855538af",
      "Severity": 1,
      "Length": 5.5,
      "Minutes": 6,
      "Speed": 59,
      "Start": "I-44",
      "End": "DOWNTOWN TULSA",
      "Direction": "West|East",
      "Names": "US-64 W|I-444 E",
      "Name": "I-44 &amp; BA EXPY TO DWTN"
    },
    {
      "Id": "9cb5d26c-73d2-4023-bdac-91dc1b3af1a5",
      "Severity": 1,
      "Length": 9.3,
      "Minutes": 9,
      "Speed": 63,
      "Start": "US-75",
      "End": "US-169",
      "Direction": "West|East|West|East|East|South",
      "Names": "I-444 W|US-64 E|I-44 W|I-44 E|US-64 E|US-169 S",
      "Name": "US-75 TO US-169"
    },
    {
      "Id": "9ed683e7-cc81-41d1-b90f-d4559b1c97fc",
      "Severity": 1,
      "Length": 98.4,
      "Minutes": 89,
      "Speed": 66,
      "Start": "DOWNTOWN TULSA",
      "End": "OKC",
      "Direction": "West",
      "Names": "I-44 W",
      "Name": "TULSA TO OKC"
    },
    {
      "Id": "1f1d98a1-bd3f-4ede-a044-be2f21d69a7f",
      "Severity": 1,
      "Length": 8.2,
      "Minutes": 9,
      "Speed": 56,
      "Start": "96TH ST S",
      "End": "DOWNTOWN",
      "Direction": "North|North|East|North",
      "Names": "Okmulgee Bee Line Expy N|Okmulgee Expy N|I-244 E|I-444 N",
      "Name": "96TH ST S TO DWTN"
    },
    {
      "Id": "86fc7e57-2dd4-4bf6-9e48-4fb7814d93f9",
      "Severity": 1,
      "Length": 5,
      "Minutes": 5,
      "Speed": 64,
      "Start": "US-75",
      "End": "I-244",
      "Direction": "South|East",
      "Names": "US-75 S|OK-11 E",
      "Name": "US-75 TO I-244"
    },
    {
      "Id": "aead6a9e-f6fa-4f7f-8293-8ffdf699f31a",
      "Severity": 1,
      "Length": 6.2,
      "Minutes": 5,
      "Speed": 70,
      "Start": "US-169",
      "End": "MUSKOGEE TPKE",
      "Direction": "East",
      "Names": "OK-51 E",
      "Name": "US-169 TO MKO TPKE"
    },
    {
      "Id": "b1661c41-6702-463d-8783-377e7e66a4ba",
      "Severity": 1,
      "Length": 27,
      "Minutes": 24,
      "Speed": 68,
      "Start": "Tulsa",
      "End": "I-44 Eastbound - Tollgate Rd ...",
      "Direction": "East|East",
      "Names": "I-244 E|I-44 E",
      "Name": "DOWNTOWN TO CLAREMORE"
    },
    {
      "Id": "aa1c6101-021a-4b36-8a62-13728c7740a0",
      "Severity": 1,
      "Length": 27,
      "Minutes": 25,
      "Speed": 65,
      "Start": "CLAREMORE",
      "End": "DOWNTOWN",
      "Direction": "West|West",
      "Names": "I-44 W|I-244 W",
      "Name": "CLAREMORE TO DWTN TULSA"
    },
    {
      "Id": "8f7b61c6-b4c3-4144-96be-c3995ee8c387",
      "Severity": 2,
      "Length": 4,
      "Minutes": 5,
      "Speed": 47,
      "Start": "I-44",
      "End": "DOWNTOWN (VIA RIVERSIDE)",
      "Direction": "",
      "Names": "",
      "Name": "I-44 TO DWTN VIA RIVERSIDE"
    },
    {
      "Id": "8eee8fd2-8770-45c5-b6f9-90ab17aca905",
      "Severity": 3,
      "Length": 2.6,
      "Minutes": 7,
      "Speed": 22,
      "Start": "US-169",
      "End": "I-44",
      "Direction": "West|East",
      "Names": "US-64 W|I-44 E",
      "Name": "US-169 TO I-44"
    },
    {
      "Id": "90ec445d-1f71-4b47-8d97-116aa1769655",
      "Severity": 1,
      "Length": 7.5,
      "Minutes": 7,
      "Speed": 63,
      "Start": "Downtown",
      "End": "US-75 Southbound - W 71st St ...",
      "Direction": "West|West|West|South",
      "Names": "I-244 W|US-412 W|I-244 W|Okmulgee Expy S",
      "Name": "DWTN TO 71ST STREET"
    },
    {
      "Id": "d6f1a048-4f2f-4fff-9cd7-6f23f646a065",
      "Severity": 1,
      "Length": 7.2,
      "Minutes": 7,
      "Speed": 64,
      "Start": "SAND SPRINGS",
      "End": "DOWNTOWN TULSA",
      "Direction": "East|East",
      "Names": "US-412 E|I-244 E",
      "Name": "OK-97 TO DWTN TULSA"
    },
    {
      "Id": "a4eeaef7-f118-4226-aacf-367977c9e1a3",
      "Severity": 2,
      "Length": 9.8,
      "Minutes": 12,
      "Speed": 48,
      "Start": "151ST",
      "End": "I-44",
      "Direction": "North|North|North",
      "Names": "S Union Ave N|Okmulgee Bee Line Expy N|Okmulgee Expy N",
      "Name": "151ST TO I-44"
    },
    {
      "Id": "a4c95127-a817-48c3-a630-d18dfec37886",
      "Severity": 2,
      "Length": 16.3,
      "Minutes": 22,
      "Speed": 45,
      "Start": "US-169 &amp; CREEK TPKE",
      "End": "DOWNTOWN TULSA",
      "Direction": "North|West|West|West|East",
      "Names": "US-169 N|US-64 W|I-444 W|I-244 W|I-244 E",
      "Name": "US-169 &amp; CREEK TPKE TO DWTN"
    },
    {
      "Id": "b5b1c64a-91d9-4db6-b329-6a17c6817b70",
      "Severity": 1,
      "Length": 12.7,
      "Minutes": 11,
      "Speed": 71,
      "Start": "OK-20",
      "End": "US-412",
      "Direction": "West|West",
      "Names": "I-44 W|US-412 W",
      "Name": "OK-20 TO US-412"
    },
    {
      "Id": "fb19a3e7-047b-4be2-8dd8-93feb38f24aa",
      "Severity": 1,
      "Length": 5.7,
      "Minutes": 6,
      "Speed": 61,
      "Start": "DOWNTOWN TULSA",
      "End": "I-44 E -&gt; US-64 E- I-44 ...",
      "Direction": "East",
      "Names": "US-64 E",
      "Name": "DOWNTOWN TO I-44"
    },
    {
      "Id": "e5cf7456-8f9b-4b62-b497-ec8ec3e8bd56",
      "Severity": 1,
      "Length": 4.6,
      "Minutes": 4,
      "Speed": 64,
      "Start": "CREEK TPKE",
      "End": "BA EXPY",
      "Direction": "North",
      "Names": "US-169 N",
      "Name": "CREEK TPKE TO BA EXPY"
    },
    {
      "Id": "c24a7e61-51fe-442d-896d-fa0f024d3ab9",
      "Severity": 1,
      "Length": 11.5,
      "Minutes": 10,
      "Speed": 67,
      "Start": "OWASSO",
      "End": "I-244",
      "Direction": "South",
      "Names": "US-169 S",
      "Name": "OWASSO TO I-244"
    },
    {
      "Id": "e82f7be2-a19f-4f9c-9775-6b6914cab1c5",
      "Severity": 1,
      "Length": 9.6,
      "Minutes": 10,
      "Speed": 57,
      "Start": "CREEK TPKE",
      "End": "DOWNTOWN",
      "Direction": "North|North|East|West",
      "Names": "Okmulgee Bee Line Expy N|Okmulgee Expy N|I-244 E|I-244 W",
      "Name": "CREEK TPKE TO DWTN"
    },
    {
      "Id": "af3531d2-885a-45a1-bb9f-0f42a933e251",
      "Severity": 2,
      "Length": 9.2,
      "Minutes": 14,
      "Speed": 40,
      "Start": "US-169 ",
      "End": "US-75",
      "Direction": "West|East|North",
      "Names": "US-64 W|I-444 E|US-75 N",
      "Name": "US-169 TO US-75"
    },
    {
      "Id": "cf8a4609-74b8-4de1-ab01-a55e07cf6ced",
      "Severity": 2,
      "Length": 10.3,
      "Minutes": 14,
      "Speed": 45,
      "Start": "TULSA HILLS",
      "End": "DOWNTOWN VIA I-44/I-244",
      "Direction": "North|West|East|North|East|East",
      "Names": "Okmulgee Expy N|I-44 W|I-244 E|Osage Expy N|US-412 E|I-244 E",
      "Name": "71ST TO DWTN VIA I-44/I-244"
    },
    {
      "Id": "5e188ee1-93ea-42fb-8bab-479520962219",
      "Severity": 2,
      "Length": 9,
      "Minutes": 13,
      "Speed": 40,
      "Start": "W Wekiwa Rd- ... Wilson Ave",
      "End": "OK-97- I-44 E|I-44 ...",
      "Direction": "",
      "Names": "",
      "Name": "SAND SPRINGS TO SAPULPA"
    },
    {
      "Id": "7cd7a9d0-a558-44e3-b8bb-a015b7867e2f",
      "Severity": 1,
      "Length": 15.9,
      "Minutes": 15,
      "Speed": 65,
      "Start": "SKIATOOK",
      "End": "TULSA",
      "Direction": "South|South|West",
      "Names": "N Highway 75 S|US-75 S|I-244 W",
      "Name": "SKIATOOK TO DWTN TULSA"
    },
    {
      "Id": "6c6f7e47-78ee-47fe-a27a-5b8b9c2f645f",
      "Severity": 1,
      "Length": 16.1,
      "Minutes": 14,
      "Speed": 68,
      "Start": "DOWNTOWN TULSA",
      "End": "SKIATOOK",
      "Direction": "East|North|North",
      "Names": "I-244 E|US-75 N|N Highway 75 N",
      "Name": "DOWNTOWN TO SKIATOOK"
    },
    {
      "Id": "dc8e1482-a5ac-4cc6-9080-a3e3a6beb3ef",
      "Severity": 3,
      "Length": 9.9,
      "Minutes": 16,
      "Speed": 37,
      "Start": "I-44",
      "End": "OK-51- ... US-412",
      "Direction": "",
      "Names": "",
      "Name": "SAPULPA TO SAND SPRINGS"
    },
    {
      "Id": "16eef0a5-4194-4393-b636-6ff612e800f3",
      "Severity": 1,
      "Length": 14.4,
      "Minutes": 13,
      "Speed": 66,
      "Start": "Tulsa",
      "End": "BA",
      "Direction": "East|East",
      "Names": "US-64 E|OK-51 E",
      "Name": "DWTN TULSA TO DWTN BA"
    },
    {
      "Id": "365d0a6a-6314-41f5-9dcf-735d92f2e165",
      "Severity": 2,
      "Length": 11.8,
      "Minutes": 15,
      "Speed": 47,
      "Start": "SAPULPA",
      "End": "I-444 W -&gt; I-244 W Southbound - I-444 ...",
      "Direction": "East|East|East",
      "Names": "New Sapulpa Rd E|I-44 E|I-244 E",
      "Name": "SAPULPA TO DWTN TULSA"
    },
    {
      "Id": "c22af388-00bf-4295-8458-3589462e6b27",
      "Severity": 2,
      "Length": 18.2,
      "Minutes": 23,
      "Speed": 48,
      "Start": "GLENPOOL",
      "End": "DOWNTOWN TULSA",
      "Direction": "North|North|North|West|East|West|West|East",
      "Names": "S Union Ave N|Okmulgee Bee Line Expy N|Okmulgee Expy N|I-44 W|I-244 E|US-412 W|I-244 W|I-244 E",
      "Name": "GLENPOOL TO DWTN TULSA"
    },
    {
      "Id": "b760e0f9-ccde-43a1-8ebb-8e8744859af0",
      "Severity": 1,
      "Length": 2.3,
      "Minutes": 2,
      "Speed": 67,
      "Start": "I-44",
      "End": "US-169",
      "Direction": "East",
      "Names": "US-64 E",
      "Name": "I-44 TO US-169"
    },
    {
      "Id": "80ec5270-5f67-4706-978f-28ca4c7cc095",
      "Severity": 1,
      "Length": 16.9,
      "Minutes": 16,
      "Speed": 64,
      "Start": "96TH ST N",
      "End": "DOWNTOWN",
      "Direction": "South|West",
      "Names": "US-169 S|I-244 W",
      "Name": "OWASSO TO DWTN TULSA"
    },
    {
      "Id": "d55ada1a-df1a-47b3-bda6-adc442ff8b15",
      "Severity": 1,
      "Length": 18,
      "Minutes": 20,
      "Speed": 55,
      "Start": "BA (LYNN LANE)",
      "End": "DOWNTOWN VIA US-169/I-244",
      "Direction": "West|North|West",
      "Names": "OK-51 W|US-169 N|I-244 W",
      "Name": "BA TO DWTN VIA US-169/I-244"
    }
  ]
}

export default traffic



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TestData/traffic.js